import React, { FC, PropsWithChildren } from 'react';
import { View } from '@tarojs/components';

interface IBadgeProps {
  dot?: boolean; // 是否展示红点
  value: string | number; // 徽标值
  maxValue: number; // 徽标最大值
  className?: string;
}

const Badge: FC<PropsWithChildren<IBadgeProps>> = ({ dot = false, value = '', maxValue = 99, children, className = '' }) => {
  // 处理value展示
  const formatValue = () => {
    const numValue = +value;
    if (Number.isNaN(numValue)) {
      return numValue;
    }

    return numValue > maxValue ? `${maxValue}+` : numValue;
  };

  const badgeVal = formatValue();

  return (
    <View className={`ace-badge ${className}`}>
      {children}
      {dot && <View className="ace-badge-dot" />}
      {!dot && badgeVal !== '' && <View className="ace-badge-num">{badgeVal}</View>}
    </View>
  );
};

export default Badge;
